import Vue from 'vue'

export const mutations = {
  cartLoaded(state, payload) {

    state.items = payload.items;
    state.order_id = payload.order_id;
    if(typeof payload.shipment !== 'undefined' ) {
      if ('internal_name' in payload.shipment) {
        state.shipment = payload.shipment;
      }
    }
    if(typeof payload.payment !== 'undefined' ) {
      if ('internal_name' in payload.payment) {
        state.payment = payload.payment;
      }
    }
    if(typeof payload.discount !== 'undefined' ) {
      state.discount = payload.discount;
    }
    //
    if(typeof window.flashMessages === 'object' || window.alerts === 'array' )
    {
      Vue.set(state,'alerts',window.flashMessages);
    }

  },

  loadShipments(state, payload) {
    state.shipments = payload;
  },

  loadPayments(state, payload) {
    state.payments = payload;
  },

  setItemQty(state, payload) {
    state.items[payload.sku].qty = payload.qty;
  },

  removeItem(state, sku) {
    Vue.delete(state.items, sku);
  },

  setSelectedShipment(state, payload) {
    Vue.set(state,'shipment', {
      cost: payload.data.cost,
      shipment_id: payload.data.id,
      internal_name: payload.data.internal_name,
      name: 'CART_' + payload.data.internal_name
    });
  },
  unsetShipment(state,payload) {
    Vue.set(state,'shipment', {
      cost: 0,
      shipment_id: -1,
      internal_name: "",
      name: ""
    });
  },

  setSelectedPayment(state, payload) {
    Vue.set(state,'payment', {
      payment_id: payload.data.id,
      internal_name: payload.data.internal_name,
      name: 'CART_' + payload.data.internal_name
    });
  },


  setDiscountCode(state, payload) {
    Vue.set(state, 'discount', {
      id: payload.id,
      discount_amount: payload.discount_amount,
      discount_percentage: payload.discount_percentage,
    });
  },
  removeDiscount(state) {
    Vue.set(state, 'discount', null);
  },

  removeAlert(state,payload) {
    Vue.delete(state.alerts[payload.type], payload.index);
  },
  loadAddresses(state,payload) {
    if('BILLING' in payload) {
      state.addresses.billing = payload.BILLING;
    }
    if('SHIPPING' in payload) {
      state.addresses.shipping = payload.SHIPPING;
    }
  },
  loadComment(state,payload) {
    if(typeof payload === 'string') {
      state.comment = payload;
    } else  {
      console.log(typeof payload);
    }
  },
  saveComment(state, payload) {
    if(typeof payload === 'string') {
      state.comment = payload;
    } else  {
      console.log(typeof payload);
    }
  },
  approvedProcessing(state, isApproved)
  {
    state.approvedProcessing = isApproved;
  },
  approvedMarketing(state, isApproved)
  {
    state.approvedMarketing= isApproved;
  },
  approvedMailing(state, isApproved)
  {
    state.approvedMailing = isApproved;
  }

};



// WEBPACK FOOTER //
// ./src/store/mutations.js